import { render, staticRenderFns } from "./btn-list.vue?vue&type=template&id=01e5d096&"
import script from "./btn-list.vue?vue&type=script&lang=js&"
export * from "./btn-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports